import React, {useEffect, useState} from 'react'
import { Steps } from 'antd'
import { ajaxApi } from '../../../server/index'
import {getParmUrl} from '../../../public/utils'
import _lodash, { get,set, toNumber } from 'lodash'
import common from '@/public/common'
import BasicInformation from './basic-information'
import SixFacesChart from './six-faces-chart'
import CooperationInformation from './cooperation-information'
import {initData} from '@/pages/commoditymanagement/addinfomation/utils'
const { Step } = Steps
// var api = 'http://192.168.10.220:8120/'||common.scpUrl+""
var api = common.scpUrl+""
const AddInfomation = () => {
  const [addData, setaddData] = useState(JSON.parse(sessionStorage.getItem('addData')))
  const [current, setcurrent] = useState(0)
  const [categoryArrTitle, setCategoryArrTitle] = useState([])
  const [categoryName, setCategoryName] = useState();
  const [currentList, setcurrentList] = useState([])
  //品牌商list
  const [brandCompanys,setBrandCompanys] = useState([])
  //贸易术语
  const [tradeCodes,setTradeCodes] = useState([])
  //品牌list 
  const [brandArr,setBrandArr] = useState([])

  const handleChangeCurrent = (key) => {
    setcurrent(key)
  }

  const getCurrent = (value) => {
    setcurrent(value)
  }

  // 获取详情
  const getDetailsData = async () => {
    const res = await ajaxApi({
      url:  api+'item/query-detail',
      params: {id: getParmUrl('id') || null}
    })
    if (res.status === 200) {
      if(get(res,"data.item_info.spec_unit")){
        // 规格中，如果有单位，那spec为数字
        res.data.item_info.spec = res.data.item_info.spec?toNumber(res.data.item_info.spec):res.data.item_info.spec
      }
      var detailsData = res.data
      _lodash.set(detailsData,'extend_propertys',_lodash.reject(_lodash.get(detailsData,'extend_propertys',[]),['property_name','ContactsType']))
      setaddData(detailsData)
      initData(detailsData)
    }
  }
  // 查询类别
  const getQueryCategory = async () => {
    try {
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-category',
        params: {}
      })
      if (res.status === 200 && res.data) {
        setCategoryArrTitle(res.data.data);
      } else {
        setCategoryArrTitle([]);
      }
    } catch (e) {
    }
  }
  const getCurrencyList= async () => {
    try {
      let res = await ajaxApi({
        url: common.scpUrl+'item/queryAllCurrency',
        params: {}
      })
      setcurrentList(get(res,'data.data')||[])
    } catch (e) {
    }
  }
  const getBrandCompanys= async () => {
    //查询品牌商
    try {
      let res = await ajaxApi({
        url: api+'item/query-brand-sid',
        params: {}
      })
      setBrandCompanys(get(res,'data.data')||[])
    } catch (e) {
    }
  }

  const getTradeCodes= async () => {
    //查询品牌商
    try {
      let res = await ajaxApi({
        url: api+'item/query-trade-code',
        params: {}
      })
      setTradeCodes(get(res,'data.data')||[])
    } catch (e) {
    }
  }

  // 查询品牌
  const getQueryBrand = async () => {
    try {
      let res = await ajaxApi({
        url: api+'item/query-all-brands',
        params: {}
      })
      if (res.status === 200 && res.data.data && res.data.data.length !== 0) {
        var brandArr = res.data.data
        setBrandArr(brandArr)
       
      } else {
        setBrandArr([])
      }
    } catch (e) {
    }
  }


  useEffect(() => {
    getCurrencyList()
    getBrandCompanys()
    getTradeCodes()
    getQueryBrand()
    if (getParmUrl('id')) {
      getDetailsData()
    }
    if (getParmUrl('categoryid')) {
      getQueryCategory();
    }
  }, [])
  useEffect(() => {
    categoryArrTitle.forEach((item, index) => {
      if (item.id == getParmUrl('categoryid')) {
        setCategoryName(item.name)
      }
    })
  }, [categoryArrTitle])

  return (
    <div>
      <div
        style={{marginBottom: '16px', marginLeft: '1.5%', fontSize: '20px', fontWeight: 'bold'}}
      >
        {`${categoryName || ''}(${getParmUrl('iscrossborder') == 1 ? '海淘' : '非海淘'})：`}
      </div>
      <div className="addGood">
        <div className="search">
          <div style={{width: '70%', margin: '0 auto'}}>
            <Steps current={current} onChange={handleChangeCurrent}>
              <Step title="步骤1" description="填写商品基本信息" />
              <Step title="步骤2" description="上传商品六面图" />
              <Step title="步骤3" description="填写合作政策" />
            </Steps>
          </div>
          <div style={{width: '100%', margin: '0 auto', marginTop: '24px'}}>
            {current === 0 ? <BasicInformation getCurrent ={getCurrent} data={addData} brandArr={brandArr}/> : null}
            {current === 1 ? <SixFacesChart getCurrent ={getCurrent}/> : null}
            {current === 2 && <CooperationInformation getCurrent ={getCurrent} currentList={currentList} 
            brandCompanys={brandCompanys} tradeCodes={tradeCodes}  brandArr={brandArr}/>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddInfomation



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addinfomation/add-infomation.js